import * as types from '../actionTypes/lookupCode'

let defaultState = {
  genders: [],
  qualifications: [],
  skills: [],
  regions: []
}

const lookupCodeReducer = (state = defaultState, action) => {
  if (action.type === types.GET_GENDERS) {
    return {
      ...state,
      genders: action.genders
    }
  } else if (action.type === types.GET_QUALIFICATIONS) {
    return {
      ...state,
      qualifications: action.qualifications
    }
  } else if (action.type === types.GET_SKILLS) {
    return {
      ...state,
      skills: action.skills
    }
  } else if (action.type === types.GET_REGIONS) {
    return {
      ...state,
      regions: action.regions
    }
  } else {
    return {
      ...state
    }
  }
}

export default lookupCodeReducer


// WEBPACK FOOTER //
// ./src/reducers/lookupCode.js